import TASK_PLUGIN from "./TASK_PLUGIN.svg";
import APPROVAL_PLUGIN from "./APPROVAL_PLUGIN.svg";
import EXTERNAL_PLUGIN from "./EXTERNAL_PLUGIN.svg";
import GENERATE_DOCUMENT_PLUGIN from "./GENERATE_DOCUMENT_PLUGIN.svg";
import API_PLUGIN from "./API_PLUGIN.svg";
import DATA_EXPORT_PLUGIN from "./DATA_EXPORT_PLUGIN.svg";
import PROCESS_PLUGIN from "./PROCESS_PLUGIN.svg";
import ADVANCED_LOGIC_PLUGIN from "./ADVANCED_LOGIC_PLUGIN.svg";
import GENERAL_START_PLUGIN from "./GENERAL_START_PLUGIN.svg";
import EXTERNAL_SOURCE_PLUGIN from "./EXTERNAL_SOURCE_PLUGIN.svg";
import GENERAL_END_PLUGIN from "./GENERAL_END_PLUGIN.svg";
import EXPOSE_API_PLUGIN from "./EXPOSE_API_PLUGIN.svg";
import EXCLUSIVE_GATEWAY_PLUGIN from "./EXCLUSIVE_GATEWAY_PLUGIN.svg";
import PARALLEL_GATEWAY_PLUGIN from "./PARALLEL_GATEWAY_PLUGIN.svg";
import JOIN_GATEWAY_PLUGIN from "./JOIN_GATEWAY_PLUGIN.svg";
import BLOCKCHAIN_PLUGIN from "./BLOCKCHAIN_PLUGIN.svg";
import BLOCKCHAIN_EVENT_PLUGIN from "./BLOCKCHAIN_EVENT_PLUGIN.svg";
import START_BLOCKCHAIN_EVENT_PLUGIN from "./START_BLOCKCHAIN_EVENT_PLUGIN.svg";

export default { TASK_PLUGIN,
    APPROVAL_PLUGIN,
    EXTERNAL_PLUGIN,
    GENERATE_DOCUMENT_PLUGIN,
    API_PLUGIN,
    DATA_EXPORT_PLUGIN,
    PROCESS_PLUGIN,
    ADVANCED_LOGIC_PLUGIN,
    GENERAL_START_PLUGIN,
    EXTERNAL_SOURCE_PLUGIN,
    GENERAL_END_PLUGIN,
    EXPOSE_API_PLUGIN,
    EXCLUSIVE_GATEWAY_PLUGIN,
    PARALLEL_GATEWAY_PLUGIN,
    JOIN_GATEWAY_PLUGIN,
    BLOCKCHAIN_PLUGIN,
    START_BLOCKCHAIN_EVENT_PLUGIN,
    BLOCKCHAIN_EVENT_PLUGIN };
